const ForcedActionCrmType = { EMAIL: 'email', PHONE: 'telefon' };
export default ForcedActionCrmType;
export const { EMAIL, PHONE } = ForcedActionCrmType;
